export const _getSystemConfigurationForm = (state, action) => action.payload;

export const _setIepResponsibleUsers = (state, action) => {
  state.iepResponsibleUsers = action.payload;
};
